import { render, staticRenderFns } from "./ModalFrame.vue?vue&type=template&id=4603e500&lang=pug&"
import script from "./ModalFrame.vue?vue&type=script&lang=js&"
export * from "./ModalFrame.vue?vue&type=script&lang=js&"
import style0 from "./ModalFrame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports